import getMessage from 'src/background/utils/i18n.utils';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { AccountAuthoritiesListComponent } from '@popup/steem/pages/app-container/settings/accounts/manage-account-authorities/account-authorities-list/account-authorities-list.component';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { SelectAccountSectionComponent } from 'src/common-ui/select-account-section/select-account-section.component';
const ManageAccountAuthorities = ({ setTitleContainerProperties, }) => {
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_manage_accounts_authorities',
            isBackButtonEnabled: true,
        });
    }, []);
    return (React.createElement("div", { className: "settings-manage-account-authorities", "data-testid": `${Screen.SETTINGS_MANAGE_ACCOUNTS_AUTHORITIES}-page` },
        React.createElement("div", { className: "text" }, getMessage('popup_html_manage_accounts_authorities_text')),
        React.createElement(SelectAccountSectionComponent, { fullSize: true, background: "white" }),
        React.createElement(AccountAuthoritiesListComponent, null)));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, { setTitleContainerProperties });
export const ManageAccountAuthoritiesComponent = connector(ManageAccountAuthorities);
